import { Navigate, Route, Routes, useLocation, useSearchParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import LogRocket from 'logrocket';
import ReactGA from 'react-ga4';

import Header from 'components/Header/Header';
import UserDashboardV4 from 'views/UserDashboard/UserDashboardV4/UserDashboardV4';
import { LanguageSelfAssessment } from './components/forms/langSelfAssesPage/LangSelfAssessment';
import AssessmentReport from 'views/assessmentPage/AssessmentReport';

import ProviderProfile from 'views/ProviderProfile/ProviderProfile';
import PermissionsPage from 'views/ProviderProfile/Permissions/PermissionsPage/PermissionsPage';
import PermissionsPageV2 from 'views/v2/permissions/containers';
import AnalyticsShell from 'views/Analytics/AnalyticsShell';
import TodayView from 'views/Analytics/containers/TodayView/TodayView';
import ConversionView from 'views/Analytics/containers/ConversionView/ConversionView';
import RevenueView from 'views/Analytics/containers/RevenueView/RevenueView';
import OperationsView from 'views/Analytics/containers/OperationsView/OperationsView';
import AdminAnalyticsView from 'views/Analytics/containers/AdminAnalyticsView';
import AddUserPage from 'views/ProviderProfile/Permissions/AddUserPage/AddUserPage';
import EditPage from 'views/ProviderProfile/Permissions/EditPage/EditPage';
import ContractTemplate from 'views/ProviderProfile/ContractTemplate/ContractTemplate';
import Settings from 'views/ProviderProfile/Settings/Settings';
import VisaOffers from 'views/ProviderProfile/VisaOffers/VisaOffers';

import FormServiceProviderPage from './views/ServiceProviderForm';
import ProtectedRoute from './contexts/ProtectedRoute';
import { FeatureProtectedRoute, PartnerOrganizationsRoute } from './contexts/FeatureProtectedRoute';
import FormPage from './views/FormPage';
import Layout from './components/Layout';
import Missing from 'views/v2/errors/containers/missing';
import Unauthorized from 'views/v2/errors/containers/unauthorized';
import ROLE from './assets/userRoles.json';
import DOMAIN from './assets/domains.json';

import GeneralInfo from 'views/assessmentPage/Questionnaire/GeneralInfo';
import Education from 'views/assessmentPage/Questionnaire/Education';
import JobOffer from 'views/assessmentPage/Questionnaire/JobOffer';
import WorkExperience from 'views/assessmentPage/Questionnaire/WorkExperience';
import RelativeAbroad from 'views/assessmentPage/Questionnaire/RelativeAbroad';
import LanguageProficiency from 'views/assessmentPage/Questionnaire/LanguageProficiency';
import Business from 'views/assessmentPage/Questionnaire/Business';
import UserInfo from 'views/ServiceProviderOverview/forms/user';
import LicenseInfo from 'views/ServiceProviderOverview/forms/license';
import CompanyInfo from 'views/ServiceProviderOverview/forms/company';
import AdditionalConsultantsInfo from 'views/ServiceProviderOverview/forms/additionalConsultants';
import BankAccountDetailsInfo from 'views/ServiceProviderOverview/forms/bankAccountDetails';
import TermOfUSeInfo from 'views/ServiceProviderOverview/forms/termOfUse';
import ServiceProviderOverview from 'views/ServiceProviderOverview/ServiceProviderOverview';
import Purpose from 'views/assessmentPage/Questionnaire/Purpose';
import { useEffect, useState } from 'react';
import { deviceType } from 'react-device-detect';
import { getLocation } from './utils/location';
import { RootState } from './redux/store';
import ChatPageNew from './views/ChatPage/ChatNew/ChatPageNew';
import { BackendEventProps } from 'api/models/payload/EventsPayload';
import $api from 'api';
import storage from 'utils/storageController';
import { useWindowSize } from 'hooks/useWindowSize';
import LicenseAndLanguage from 'views/ProviderProfile/LicenseAndLanguage/LicenseAndLanguage';
import LicenseDetails from 'views/v2/license/containers';
import SalesIndex from 'views/Dashboards-B2B/components/BACKOFFICEFLOW/MYCLIENTS/components/dashboard/salesOnboarding';
import SalesOnboarding from 'views/Dashboards-B2B/components/BACKOFFICEFLOW/MYCLIENTS/components/dashboard/salesOnboarding/views/Onboarding/salesOnboarding';
import OnboardingFormPage from 'views/Dashboards-B2B/components/BACKOFFICEFLOW/MYCLIENTS/components/dashboard/salesOnboarding/components/OnboardingFormPage/FormPage';
import OnboardingQuestionnaire from 'views/Dashboards-B2B/components/BACKOFFICEFLOW/MYCLIENTS/components/dashboard/salesOnboarding/components/Results/Results';
import OnboardingAgreement from 'views/Dashboards-B2B/components/BACKOFFICEFLOW/MYCLIENTS/components/dashboard/salesOnboarding/views/AgreementModal/CreateAgreementModal';
import Dashboard from 'views/Dashboards-B2B/Dashboard';
import MainDashboard from 'views/Dashboards-B2B/components/BACKOFFICEFLOW/MYCLIENTS/components/dashboard/MainDashboard';
import Notifications from 'views/v2/Dashboards-B2B/components/backOfficeFlow/notifications/containers';
import ClientView from 'views/Dashboards-B2B/components/BACKOFFICEFLOW/CLIENTVIEW/ClientView';
import ClientProfile from 'views/Dashboards-B2B/components/BACKOFFICEFLOW/CLIENTVIEW/components/ClientProfile/ClientProfile';
import ClientViewChat from 'views/v2/Dashboards-B2B/components/backOfficeFlow/clientView/chat/containers';
import ClientDocuments from 'views/Dashboards-B2B/components/BACKOFFICEFLOW/CLIENTVIEW/components/Documents/ClientDocuments';
import ClientNotesV2 from 'views/v2/Dashboards-B2B/components/backOfficeFlow/notes/containers';
import VisaOffersB2B from 'views/Dashboards-B2B/components/CLIENTFLOW/visa-offers/VisaOffers';
import DocumentsB2B from 'views/Dashboards-B2B/components/CLIENTFLOW/documents/Documents';
import ClientFlowChat from 'views/Dashboards-B2B/components/CLIENTFLOW/chats/ClientFlowChat';
import AgreementB2B from 'views/Dashboards-B2B/components/CLIENTFLOW/agreement/Agreement';
import CandidateDashboard from 'views/Dashboards-B2B/components/CLIENTFLOW/CandidateDashboard';
import NoApplicationPage from 'views/v2/applicant/noApplication/containers';
import { DomainKey } from 'data/constants/domainApiKey';
import useEnabledCountries from 'hooks/useEnabledCountries';
import { ACCOUNT_HOME, rolesForEnabledCountries } from 'utils/countries';
import { ADMIN_ROLES, LICENSE_MENU_ROLES } from 'data/constants/roles';
import { FEATURE } from 'constant/features';
import AssessmentFee from 'views/ProviderClients/MyClients/views/Agreement/components/MilestonesAndFees/AsessmentFee';
import AdminPanel from 'views/ProviderProfile/AdminPanel/AdminPanel';
import AdminPanelV2 from 'views/v2/adminPanel/containers';
import ServicesDocumentsPage from 'views/v2/servicesDocuments/containers';
import EventTracker from 'views/v2/eventTracker/containers';
import { checkForVersionUpdates } from 'versionUpdate';
import CandidateDashboardWrapper from 'views/Dashboards-B2B/components/CLIENTFLOW/CandidateDashboardWrapper';
import Financials from 'views/ProviderProfile/Financials/Financials';
import SubscriptionSuccess from 'views/SubscriptionSuccess/SubscriptionSuccess';
import OldOnboardingAgreement from 'views/Dashboards-B2B/components/BACKOFFICEFLOW/MYCLIENTS/components/dashboard/salesOnboarding/views/AgreementModal/OldOnboardingAgreement';
import TemplatesPage from 'views/v2/retainerAgreement/containers/templatesPage';
import TemplateEditorWrapper from 'views/retainerAgreement/TemplateEditorWrapper';
import SignatureManagement from 'views/signatureManagement/SignatureManagement';
import SignatureManagementV2 from 'views/v2/signatures/containers';
import AgreementDashboardV2 from 'views/v2/Dashboards-B2B/components/backOfficeFlow/clientView/agreement/containers';
import AliroChatWidget from 'components/common/chatbot/Chat';
import AppAlert from 'components/common/appAlert';
import OrganizationLayout from 'views/v2/Dashboards-B2B/components/clientFlow/organization/containers/organizationLayout';
import OrganizationProfileForm from 'views/v2/Dashboards-B2B/components/clientFlow/organization/profile/containers';
import OrganizationDocuments from 'views/v2/Dashboards-B2B/components/clientFlow/organization/documents/containers';
import OrganizationAgreement from 'views/v2/Dashboards-B2B/components/clientFlow/organization/agreement/containers';
import OrganizationAgents from 'views/v2/Dashboards-B2B/components/clientFlow/organization/agents/containers';
import ClientDocumentsV2 from './views/v2/Dashboards-B2B/components/backOfficeFlow/documents/containers';
import Tickets from './views/v2/Dashboards-B2B/components/backOfficeFlow/tickets/containers';

import { WorkspaceProvider, useWorkspace } from 'stores/workspaceStore';
import SidebarLayout from 'components/v2/SidebarLayout';
import VisaApplicantPage from 'views/v2/applicant/visaApplication/containers';
import DashboardPage from 'views/v2/applicant/dashboard/containers';
import DocumentsPage from 'views/v2/applicant/documents/containers';
import NotificationPage from 'views/v2/applicant/notifications/containers';
import ExpertReviewPage from 'views/v2/applicant/expertReview/containers';
import SignRetainerPage from 'views/v2/applicant/signRetainer/containers';
import SignRetainerDocumentPage from 'views/v2/applicant/signRetainer/containers/retainerDocument';
import MyAccountV2 from './views/v2/auth/containers/myAccount';
import MyLicenses from 'views/v2/licenses/containers';
import AppV2ThemeWrapper from 'components/v2/appV2ThemeWrapper';
import Login from './views/v2/auth/containers/login';
import PasswordRecoveryV2 from './views/v2/auth/containers/passwordRecovery';
import ResetPasswordV2 from './views/v2/auth/containers/resetPassword';
import CreatePassword from 'views/v2/auth/containers/createPassword';
import VerificationCode from 'views/v2/auth/containers/verificationCode';

declare global {
    interface Window {
        embeddedservice_bootstrap?: {
            settings: { language: string };
            init: (id: string, name: string, url: string, config: { scrt2URL: string }) => void;
        };
        _salesforceChatInitialized?: boolean;
    }
}
const GOOGLE_ANALYTICS_TRACKING_ID = process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID;
if (GOOGLE_ANALYTICS_TRACKING_ID) ReactGA.initialize(GOOGLE_ANALYTICS_TRACKING_ID);

const LOGROCKET_TRACKING_ID = process.env.REACT_APP_LOGROCKET_TRACKING_ID;
if (LOGROCKET_TRACKING_ID) LogRocket.init(LOGROCKET_TRACKING_ID);

export default function App() {
    return (
        <WorkspaceProvider>
            <AppContent />
        </WorkspaceProvider>
    );
}

function AppContent() {
    const { isSidebarLayout: isSidebarPreference } = useWorkspace();

    const location = useLocation();
    const [queryParameters] = useSearchParams();
    const country: string = getLocation().userCountry;
    const user = useSelector((state: RootState) => state.user.entity);
    const { codes, hasCanada, hasSelfServeMarket } = useEnabledCountries();
    const hasEnabledCountry = hasCanada || hasSelfServeMarket;
    const languageAssessmentRoles = rolesForEnabledCountries(
        codes,
        [ROLE.sales, ROLE.backofficeAdmin, ROLE.superAdmin, ROLE.superSuperAdmin],
        [
            ROLE.admin,
            ROLE.superAdmin,
            ROLE.superSuperAdmin,
            ROLE.visaCandidate,
            ROLE.completedAssessment,
            ROLE.academicConsultation,
            ROLE.consultant,
        ]
    );
    const visaProcessRoles = rolesForEnabledCountries(
        codes,
        [ROLE.externalClient],
        [ROLE.completedAssessment, ROLE.academicConsultation, ROLE.externalClient]
    );

    const isSidebarLayout = isSidebarPreference && user?.role === ROLE.externalClient;

    if (user.id !== 0 && user.email !== '') {
        LogRocket.identify(String(user.id), {
            name: user.firstname + ' ' + user.lastname,
            email: user.email,
            role: user.role,
        });
    }

    useEffect(() => {
        const reloadTimestamp = new URLSearchParams(location.search).get('reload');

        if (reloadTimestamp) {
            // Remove the `reload` query param after page reload to avoid further reloads
            const currentUrl = new URL(window.location.href);
            currentUrl.searchParams.delete('reload');
            window.history.replaceState({}, '', currentUrl.toString());
        }

        checkForVersionUpdates();
    }, [location]);

    useEffect(() => {
        (async () => {
            if (storage.isAuthenticated()) {
                const url_params = window.document.referrer
                    ? new URL(window.document.referrer).searchParams
                    : null;
                const event_properties: BackendEventProps = {
                    country: country,
                    referrer: window.document.referrer,
                    device_type: deviceType,
                    utm_source:
                        queryParameters.get('utm_source') || url_params?.get('utm_source') || '',
                    utm_medium:
                        queryParameters.get('utm_medium') || url_params?.get('utm_medium') || '',
                    utm_campaign:
                        queryParameters.get('utm_campaign') ||
                        url_params?.get('utm_campaign') ||
                        '',
                    utm_content:
                        queryParameters.get('utm_content') || url_params?.get('utm_content') || '',
                    user_agent: window.navigator.userAgent,
                    anonymous_id: localStorage.ajs_anonymous_id?.replaceAll('"', ''),
                };
                try {
                    await $api.events.user_props_put(event_properties);
                } catch (err: unknown) {
                    console.log(err instanceof Error ? err.message : 'Unknown error');
                }
            }
        })();
        // eslint-disable-next-line
    }, []);

    const [width, height] = useWindowSize();
    const [mobile, setMobile] = useState(false);
    useEffect(() => {
        if (width >= 510) {
            setMobile(false);
        }
        if (width < 510) {
            setMobile(true);
        }
    }, [width, height]);

    const [position, setPosition] = useState(window.scrollY);
    const [visible, setVisible] = useState(true);
    useEffect(() => {
        const handleScroll = () => {
            const moving = window.scrollY;

            setVisible(position > moving);
            setPosition(moving);
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    });

    const cls = visible ? 'visible' : 'hidden';

    const elements = (
        <>
            <Route index path="general" element={<GeneralInfo />} />
            <Route path="purpose" element={<Purpose />} />
            <Route path="education" element={<Education />} />
            <Route path="job-offer" element={<JobOffer />} />
            <Route path="work-experience" element={<WorkExperience />} />
            <Route path="relative-abroad" element={<RelativeAbroad />} />
            <Route path="language-proficiency" element={<LanguageProficiency />} />
            <Route path="business-experience" element={<Business />} />
        </>
    );

    const providerElements = (
        <>
            <Route index element={<UserInfo />} />
            <Route path="license" element={<LicenseInfo />} />
            <Route path="company" element={<CompanyInfo />} />
            <Route path="additional-consultants" element={<AdditionalConsultantsInfo />} />
            <Route path="bank-account-details" element={<BankAccountDetailsInfo />} />
            <Route path="terms-of-use" element={<TermOfUSeInfo />} />
        </>
    );

    useEffect(() => {
        const domain = window.location.hostname;

        if (domain === 'aliro-d6903.web.app') {
            const initEmbeddedMessaging = () => {
                try {
                    if (!window.embeddedservice_bootstrap) {
                        console.error('Salesforce chat bootstrap not loaded.');
                        return;
                    }

                    window.embeddedservice_bootstrap.settings.language = 'en_US';

                    window.embeddedservice_bootstrap.init(
                        '00D0Y00000356Uq',
                        'UIS_Canada_Portal_Agent',
                        'https://immigration.my.site.com/ESWUISCanadaPortalAgen1751986602475',
                        {
                            scrt2URL: 'https://immigration.my.salesforce-scrt.com',
                        }
                    );
                } catch (err) {
                    console.error('Error loading Embedded Messaging: ', err);
                }
            };

            const script = document.createElement('script');
            script.src =
                'https://immigration.my.site.com/ESWUISCanadaPortalAgen1751986602475/assets/js/bootstrap.min.js';
            script.type = 'text/javascript';
            script.onload = initEmbeddedMessaging;

            document.body.appendChild(script);

            // Optional: clean up if needed
            return () => {
                document.body.removeChild(script);
            };
        }
    }, []);
    return (
        <>
            <AppAlert />
            {user?.role === ROLE.externalClient && DomainKey === DOMAIN.DEMO && (
                <AliroChatWidget
                    title="AI Assistant"
                    poweredBy="powered by aliro ai"
                    zIndex={70}
                    onSend={async ({ message, history }) => {
                        try {
                            // Send the full conversation history to the backend
                            const res = await $api.chat_with_ai.post({
                                message,
                                history, // Include the full conversation history
                            });

                            if (!res.data) throw new Error('Request failed');
                            return res.data.response as string; // or an array of { role, content }
                        } catch (error) {
                            console.error('Error sending message to AI:', error);
                            throw error;
                        }
                    }}
                />
            )}

            {!isSidebarLayout && user?.email && (
                <span className={mobile ? cls : ''}>
                    <Header />
                </span>
            )}
            <Routes>
                <Route path="/" element={<Layout />}>
                    {/* ═══ Public routes ═══ */}
                    <Route path="/" element={<Login />} />
                    <Route path="login" element={<Login />} />
                    <Route path="password-recovery" element={<PasswordRecoveryV2 />} />
                    <Route path="reset-password" element={<ResetPasswordV2 />} />

                    <Route path="register" element={<FormPage />} />
                    <Route path="user-verification" element={<VerificationCode />} />
                    <Route path="set-password" element={<CreatePassword />} />

                    {/* ═══ All authenticated users ═══ */}
                    <Route element={<ProtectedRoute allowedRoles={Object.values(ROLE)} />}>
                        <Route path="/chat_new" element={<ChatPageNew />} />
                        <Route path="/chat" element={<ChatPageNew />} />
                        <Route path="/templates" element={<TemplatesPage />} />
                        <Route
                            element={
                                <FeatureProtectedRoute
                                    feature={FEATURE.RETAINER_TEMPLATES}
                                    redirectTo="/templates"
                                />
                            }
                        >
                            <Route path="/templates/:id/edit" element={<TemplateEditorWrapper />} />
                            <Route path="/templates/new" element={<TemplateEditorWrapper />} />
                        </Route>
                        <Route path="/signatures" element={<SignatureManagementV2 />} />
                        <Route path="/signatures-v1" element={<SignatureManagement />} />

                        {languageAssessmentRoles.length > 0 && (
                            <Route
                                element={<ProtectedRoute allowedRoles={languageAssessmentRoles} />}
                            >
                                <Route
                                    path="language_self_assessment"
                                    element={<LanguageSelfAssessment />}
                                />
                            </Route>
                        )}

                        {/* ─── Account section ─── */}
                        <Route path="/account" element={<ProviderProfile />}>
                            <Route index element={<Navigate to="my-account" replace />} />
                            {!isSidebarLayout && (
                                <>
                                    <Route path="my-account" element={<MyAccountV2 />} />
                                    <Route
                                        path="change-password"
                                        element={
                                            <Navigate
                                                to="/account/my-account#change-password"
                                                replace
                                            />
                                        }
                                    />
                                </>
                            )}
                            <Route path="signatures" element={<SignatureManagementV2 />} />
                            <Route path="signatures-v1" element={<SignatureManagement />} />
                            <Route element={<ProtectedRoute allowedRoles={LICENSE_MENU_ROLES} />}>
                                <Route path="licenses" element={<MyLicenses />} />
                            </Route>
                            <Route
                                element={<ProtectedRoute allowedRoles={[ROLE.superSuperAdmin]} />}
                            >
                                <Route path="admin-panel" element={<AdminPanelV2 />} />
                                <Route path="admin-panel-v1" element={<AdminPanel />} />
                                <Route path="event-tracker" element={<EventTracker />} />
                            </Route>

                            <Route
                                element={
                                    <ProtectedRoute
                                        allowedRoles={[ROLE.admin, ROLE.backofficeConsultant]}
                                    />
                                }
                            >
                                <Route path="license" element={<LicenseDetails />} />
                            </Route>

                            {hasSelfServeMarket && (
                                <>
                                    <Route
                                        path="license-language"
                                        element={<LicenseAndLanguage />}
                                    />
                                    <Route path="Settings" element={<Settings />} />
                                </>
                            )}

                            {/* Admin-protected account sub-routes */}
                            <Route element={<ProtectedRoute allowedRoles={ADMIN_ROLES} />}>
                                <Route
                                    path="services-documents"
                                    element={<ServicesDocumentsPage />}
                                />
                                <Route path="permissions" element={<Outlet />}>
                                    <Route index element={<PermissionsPageV2 />} />
                                    {/* Legacy full-page create/edit routes (kept for backward compatibility) */}
                                    <Route path="add-user" element={<AddUserPage />} />
                                    <Route path="edit-user/:id" element={<EditPage />} />
                                    <Route path="v1" element={<PermissionsPage />} />
                                </Route>
                                <Route
                                    element={
                                        <FeatureProtectedRoute
                                            feature={FEATURE.FINANCIALS}
                                            redirectTo="/account/my-account"
                                        />
                                    }
                                >
                                    <Route path="financials" element={<Financials />} />
                                    <Route
                                        path="subscription/success"
                                        element={<SubscriptionSuccess />}
                                    />
                                </Route>
                                <Route path="analytics" element={<AnalyticsShell />}>
                                    <Route index element={<TodayView />} />
                                    <Route path="today" element={<TodayView />} />
                                    <Route path="conversion" element={<ConversionView />} />
                                    <Route path="revenue" element={<RevenueView />} />
                                    <Route path="operations" element={<OperationsView />} />
                                    <Route
                                        element={
                                            <ProtectedRoute allowedRoles={[ROLE.superSuperAdmin]} />
                                        }
                                    >
                                        <Route
                                            path="summary"
                                            element={
                                                <Navigate
                                                    to="/account/admin-analytics/overview"
                                                    replace
                                                />
                                            }
                                        />
                                        <Route
                                            path="provider-activity"
                                            element={
                                                <Navigate
                                                    to="/account/admin-analytics/overview"
                                                    replace
                                                />
                                            }
                                        />
                                    </Route>
                                </Route>
                                <Route
                                    element={
                                        <ProtectedRoute allowedRoles={[ROLE.superSuperAdmin]} />
                                    }
                                >
                                    <Route
                                        path="admin-analytics"
                                        element={<AnalyticsShell admin />}
                                    >
                                        <Route index element={<AdminAnalyticsView />} />
                                        <Route path="overview" element={<AdminAnalyticsView />} />
                                    </Route>
                                </Route>

                                {hasSelfServeMarket && (
                                    <Route
                                        path="contract-template"
                                        element={<ContractTemplate />}
                                    />
                                )}
                            </Route>

                            {hasSelfServeMarket && (
                                <Route
                                    element={
                                        <ProtectedRoute allowedRoles={[ROLE.completedAssessment]} />
                                    }
                                >
                                    <Route path="visa-offers" element={<VisaOffers />} />
                                </Route>
                            )}
                        </Route>
                    </Route>

                    {hasSelfServeMarket && (
                        <Route
                            element={
                                <ProtectedRoute
                                    allowedRoles={[
                                        ROLE.completedAssessment,
                                        ROLE.academicConsultation,
                                    ]}
                                />
                            }
                        >
                            <Route
                                path="/visa-options/summary"
                                element={<Navigate to="/visa-options/visa-pathway" />}
                            />
                            <Route
                                path="/visa-options/visa-pathway"
                                element={<UserDashboardV4 />}
                            />
                            <Route path="results" element={<AssessmentReport />}>
                                {elements}
                            </Route>
                        </Route>
                    )}

                    {visaProcessRoles.length > 0 && (
                        <Route element={<ProtectedRoute allowedRoles={visaProcessRoles} />}>
                            {isSidebarLayout ? (
                                <Route element={<SidebarLayout />}>
                                    <Route path="visa-process">
                                        <Route
                                            index
                                            element={<Navigate to="assessment" replace />}
                                        />
                                        <Route path="assessment" element={<VisaApplicantPage />} />
                                        <Route path="dashboard" element={<DashboardPage />} />
                                        <Route path="empty" element={<NoApplicationPage />} />
                                        <Route
                                            path="notifications"
                                            element={<NotificationPage />}
                                        />
                                        <Route path=":id">
                                            <Route path="documents" element={<DocumentsPage />} />
                                            <Route
                                                path="agreement"
                                                element={<SignRetainerPage />}
                                            />
                                            <Route
                                                path="agreement/:agreementId"
                                                element={<SignRetainerDocumentPage />}
                                            />
                                            <Route path="chats" element={<ExpertReviewPage />} />
                                            <Route
                                                path="results"
                                                element={
                                                    <OnboardingQuestionnaire showDownloadButton />
                                                }
                                            />
                                        </Route>
                                    </Route>
                                    <Route path="/account" element={<AppV2ThemeWrapper />}>
                                        <Route
                                            index
                                            element={<Navigate to="my-account" replace />}
                                        />
                                        <Route path="my-account" element={<MyAccountV2 />} />
                                        <Route
                                            path="change-password"
                                            element={
                                                <Navigate
                                                    to="/account/my-account#change-password"
                                                    replace
                                                />
                                            }
                                        />
                                    </Route>
                                </Route>
                            ) : (
                                <>
                                    <Route path="visa-process" element={<Dashboard />}>
                                        <Route
                                            index
                                            element={<Navigate to="assessment" replace />}
                                        />
                                        <Route
                                            path="assessment"
                                            element={<CandidateDashboardWrapper />}
                                        />
                                        <Route path=":id" element={<CandidateDashboard />}>
                                            <Route path="visa-offers" element={<VisaOffersB2B />} />
                                            <Route path="documents" element={<DocumentsB2B />} />
                                            <Route path="chats" element={<ClientFlowChat />} />
                                            <Route path="Agreement" element={<AgreementB2B />} />
                                            {/* Retainer email links land here in both layouts */}
                                            <Route element={<AppV2ThemeWrapper />}>
                                                <Route
                                                    path="agreement/:agreementId"
                                                    element={<SignRetainerDocumentPage />}
                                                />
                                            </Route>
                                            <Route
                                                path="results"
                                                element={<OnboardingQuestionnaire />}
                                            />
                                        </Route>
                                    </Route>
                                    <Route
                                        path="visa-process/empty"
                                        element={<NoApplicationPage />}
                                    />
                                </>
                            )}
                        </Route>
                    )}

                    {/* ═══ Admin, consultants, backoffice ═══ */}
                    <Route
                        element={
                            <ProtectedRoute
                                allowedRoles={[
                                    ROLE.sales,
                                    ROLE.admin,
                                    ROLE.superAdmin,
                                    ROLE.superSuperAdmin,
                                    ROLE.consultant,
                                    ROLE.backofficeConsultant,
                                    ROLE.backofficeAdmin,
                                ]}
                            />
                        }
                    >
                        <Route path="provider_overview" element={<ServiceProviderOverview />}>
                            {providerElements}
                        </Route>

                        <Route path="dashboard" element={<Dashboard />}>
                            <Route index element={<MainDashboard />} />
                            <Route path="cases" element={<MainDashboard />} />
                            <Route path="notifications" element={<Notifications />} />

                            {/* Sales onboarding */}
                            <Route path="sales-onboarding" element={<SalesIndex />}>
                                <Route index element={<SalesOnboarding />} />
                                <Route path="assessment/:id?" element={<OnboardingFormPage />} />
                                <Route
                                    path="assessment/:id/results"
                                    element={<OnboardingQuestionnaire />}
                                />
                                <Route path="agreement/:id?" element={<OldOnboardingAgreement />} />
                                <Route
                                    path="agreement/:id/AgreementFee"
                                    element={<AssessmentFee />}
                                />
                                <Route
                                    path="agreement/:id/visa-program/:appID"
                                    element={<OldOnboardingAgreement />}
                                />
                            </Route>

                            {/* Organization view — partner orgs require PARTNER_ORGANIZATIONS;
                                own-company profile remains reachable. */}
                            <Route path=":id/organization" element={<PartnerOrganizationsRoute />}>
                                <Route element={<OrganizationLayout />}>
                                    <Route index element={<OrganizationProfileForm />} />
                                    <Route path="agents" element={<OrganizationAgents />} />
                                    <Route path="chats" element={<ClientViewChat />} />
                                    <Route path="documents" element={<OrganizationDocuments />} />
                                    <Route path="agreement" element={<OrganizationAgreement />} />
                                </Route>
                            </Route>

                            {/* Client profile view */}
                            <Route path=":id/client-profile" element={<ClientView />}>
                                <Route index element={<ClientProfile />} />
                                <Route
                                    path=":appId?/chat"
                                    element={<ClientViewChat enableReplySuggestions />}
                                />
                                <Route path=":appId?/documents" element={<ClientDocumentsV2 />} />
                                <Route path=":appId?/documents-v2" element={<ClientDocuments />} />
                                <Route path=":appId?/tickets" element={<Tickets />} />
                                <Route path="notes" element={<ClientNotesV2 />} />
                                <Route path="results" element={<OnboardingQuestionnaire />} />
                                <Route path="eligibility" element={<OnboardingQuestionnaire />} />
                                <Route path="retainer/:appID?" element={<OnboardingAgreement />} />
                                <Route
                                    path="retainer/view/:appID?"
                                    element={<OnboardingAgreement />}
                                />
                                <Route
                                    path="retainer/view/:appID/edit"
                                    element={<OnboardingAgreement />}
                                />
                                <Route
                                    path="agreement/:appID?"
                                    element={<AgreementDashboardV2 />}
                                />
                                <Route
                                    path="agreement/:appID/edit"
                                    element={<AgreementDashboardV2 />}
                                />
                                <Route path="retainer/assessment" element={<AssessmentFee />} />
                            </Route>
                        </Route>

                        {hasEnabledCountry && (
                            <Route
                                element={
                                    <ProtectedRoute
                                        allowedRoles={[ROLE.superSuperAdmin, ROLE.superAdmin]}
                                    />
                                }
                            >
                                <Route
                                    path="register_service_provider"
                                    element={<FormServiceProviderPage />}
                                />
                            </Route>
                        )}
                    </Route>

                    {!hasSelfServeMarket && (
                        <>
                            <Route
                                path="visa-options"
                                element={<Navigate to={ACCOUNT_HOME} replace />}
                            />
                            <Route
                                path="visa-options/*"
                                element={<Navigate to={ACCOUNT_HOME} replace />}
                            />
                        </>
                    )}
                    {visaProcessRoles.length === 0 && (
                        <>
                            <Route
                                path="visa-process"
                                element={<Navigate to={ACCOUNT_HOME} replace />}
                            />
                            <Route
                                path="visa-process/*"
                                element={<Navigate to={ACCOUNT_HOME} replace />}
                            />
                        </>
                    )}
                    {languageAssessmentRoles.length === 0 && (
                        <Route
                            path="language_self_assessment"
                            element={<Navigate to={ACCOUNT_HOME} replace />}
                        />
                    )}
                    {!hasEnabledCountry && (
                        <Route
                            path="register_service_provider"
                            element={<Navigate to={ACCOUNT_HOME} replace />}
                        />
                    )}

                    {/* ═══ Special routes ═══ */}
                    <Route path="unauthorized" element={<Unauthorized />} />
                    {/* Catch all */}
                    <Route path="*" element={<Missing />} />
                </Route>
            </Routes>
        </>
    );
}
